import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from "../../utils/api";
import { toast } from 'react-toastify';

function IncidentsAdd() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        car_plate: '',
        driver_id: '', // Changed from driver_name to driver_id
        incident_description: '',
        date_time: new Date().toISOString().slice(0, 16),
        images: [],
        supervisor_approval: false
    });
    const [drivers, setDrivers] = useState([]);

    const fetchDrivers = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/drivers', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setDrivers(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to fetch drivers');
        }
    };

    useEffect(() => {
        fetchDrivers();
    }, []);

    const handleInputChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        if (type === 'file') {
            setFormData({
                ...formData,
                [name]: files
            });
        } else {
            setFormData({
                ...formData,
                [name]: type === 'checkbox' ? checked : value
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formPayload = new FormData();
            Object.keys(formData).forEach(key => {
                if (key === 'images') {
                    for (let i = 0; i < formData.images.length; i++) {
                        formPayload.append('images[]', formData.images[i]);
                    }
                } else {
                    formPayload.append(key, formData[key]);
                }
            });
            const token = localStorage.getItem('auth_token');
            await apiClient.post('accounts/incidents', formPayload, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            });
            toast.success('Incident reported successfully');
            navigate('/accounts/incidents-list');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to report incident');
        }
    };

    return (
        <div className="container-xxl">
            <PageHeader1 pagetitle="Report Incident" />
            <div className="row g-3">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Car Plate Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="car_plate"
                                            value={formData.car_plate}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Driver</label>
                                        <select
                                            className="form-control"
                                            name="driver_id"
                                            value={formData.driver_id}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="">Select Driver</option>
                                            {drivers.map(driver => (
                                                <option key={driver.id} value={driver.id}>
                                                    {driver.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label">Incident Description</label>
                                        <textarea
                                            className="form-control"
                                            name="incident_description"
                                            value={formData.incident_description}
                                            onChange={handleInputChange}
                                            rows="4"
                                            required
                                        ></textarea>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Date & Time</label>
                                        <input
                                            type="datetime-local"
                                            className="form-control"
                                            name="date_time"
                                            value={formData.date_time}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Upload Images</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            name="images"
                                            onChange={handleInputChange}
                                            multiple
                                            accept="image/*"
                                        />
                                    </div>
                                    <div className="col-12">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                name="supervisor_approval"
                                                checked={formData.supervisor_approval}
                                                onChange={handleInputChange}
                                            />
                                            <label className="form-check-label">Supervisor Approval</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <button type="submit" className="btn btn-primary me-2">Submit</button>
                                    <button type="button" className="btn btn-secondary" onClick={() => window.print()}>Print Receipt</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IncidentsAdd;